import p1 from './assets/img/products/f1.jpg';
import p2 from './assets/img/products/f2.jpg';
import p3 from './assets/img/products/f3.jpg';
import p4 from './assets/img/products/f4.jpg';
import p5 from './assets/img/products/f5.jpg';
import p6 from './assets/img/products/f6.jpg';

export const PRODUCTS=[
    {
        id:1,
        ProductName:"Shirt",
        Price:12,
        ProductImg:p1,
    },
    {
        id:2,
        ProductName:"Shirt",
        Price:12,
        ProductImg:p2,
    },
    {
        id:3,
        ProductName:"Shirt",
        Price:12,
        ProductImg:p3,
    },
    {
        id:4,
        ProductName:"Shirt",
        Price:12,
        ProductImg:p4,
    },
    {
        id:5,
        ProductName:"Shirt",
        Price:12,
        ProductImg:p5,
    },
    {
        id:6,
        ProductName:"Shirt",
        Price:12,
        ProductImg:p6,
    },
]